import * as React from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

export type RoleChipProps = {
    label: string;
    backgroundColor?: string;
    textColor?: string;
};

export const RoleChip: React.FunctionComponent<RoleChipProps> = function ({
    label,
    backgroundColor = 'primary.light',
    textColor = 'primary.dark',
}: RoleChipProps) {
    return (
        <Box
            data-testid="RoleChip-test-id"
            sx={{
                backgroundColor,
                borderRadius: '8px',
                paddingY: '6px',
                paddingX: '15px',
                gap: '2px',
                maxHeight: 'fit-content',
            }}
        >
            <Typography
                variant="l2dcaption"
                sx={{ color: textColor }}
            >
                {label}
            </Typography>
        </Box>
    );
};
